import { lazy } from '@loadable/component';

export default lazy(() => import('./P2DIWeightsPage'));
